import { tokens } from '@/design';
import { legendStyleMeta } from './legendStyles';
import type { LegendStyleId } from './layoutTypes';

export function LegendStyleThumbnail({
  styleId,
}: {
  readonly styleId: LegendStyleId;
}) {
  const style = legendStyleMeta(styleId);
  const columns = style.columnCount > 1 ? 2 : 1;
  return (
    <span
      aria-hidden
      style={{
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap: tokens.space[1],
        width: '100%',
        minHeight: 48,
        boxSizing: 'border-box',
        padding: tokens.space[1],
        background: style.background.enabled
          ? style.background.color
          : 'transparent',
        border: style.border.enabled
          ? `${tokens.border.width.thin}px solid ${style.border.color}`
          : `${tokens.border.width.thin}px dashed ${tokens.color.ink.muted}`,
      }}
    >
      <span
        style={{
          gridColumn: `1 / ${columns + 1}`,
          textAlign: style.titleAlignment,
          fontSize: style.titleSizePt * 0.55,
          fontWeight: tokens.font.weight.semibold,
        }}
      >
        A
      </span>
      {Array.from({ length: columns }, (_, column) => (
        <span
          key={column}
          style={{
            display: 'grid',
            gridTemplateColumns: `${7 * style.patchScale}px 1fr`,
            alignItems: 'center',
            gap: tokens.space[1],
          }}
        >
          <span
            style={{
              display: 'grid',
              gap: tokens.space[1],
            }}
          >
            {[tokens.color.semantic.info, tokens.color.semantic.success, tokens.color.semantic.warning].map(
              (color) => (
                <span
                  key={color}
                  style={{
                    width: 5 * style.patchScale,
                    height: 4 * style.patchScale,
                    background: color,
                    border: tokens.border.thin,
                  }}
                />
              ),
            )}
          </span>
          <span style={{ display: 'grid', gap: tokens.space[1] }}>
            {[0, 1, 2].map((line) => (
              <span
                key={line}
                style={{
                  display: 'block',
                  width: line === 1 ? '70%' : '100%',
                  height: 1,
                  background: tokens.color.ink.muted,
                }}
              />
            ))}
          </span>
        </span>
      ))}
    </span>
  );
}
